export const sortbyStyle = {
  fontSize: "0.75rem",
  fontFamily: "inherit",
  fontWeight: "400",
  color: "#252B3B",
};
